import React from "react";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";
import WorkerTimeRecordPage from "./WorkerTimeRecordPage";

interface WorkerTimeRecordPageContainerProps extends RouteProps, withValidUserRoleProps {}

const WorkerTimeRecordPageContainer = (props: WorkerTimeRecordPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <WorkerTimeRecordPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(WorkerTimeRecordPageContainer);
